import { useMediaQuery } from '../useMediaQuery';
export function useReducedMotion() {
    return useMediaQuery('(prefers-reduced-motion: reduce)');
}

//# sourceMappingURL=useReducedMotion.js.map